import { Platform } from 'quasar';
import { route } from 'quasar/wrappers';
import {
    createRouter, createMemoryHistory, createWebHistory, createWebHashHistory,
} from 'vue-router';
import auth from 'src/model/auth';
import { initPortfolioDialog } from 'src/pages/mockup/assistFunc';
import { initProjects, disableProjects } from 'src/model/projects';
import { Tasks } from 'src/model/db/tasks';
import {
    IS_INTERNAL_AUTH, SSO_CLIENT_ID, SSO_REDIRECT_URI, apiBot, queryBot2,
} from 'boot/axios';
import routes from './routes';

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default route(({ store }) => {
    // eslint-disable-next-line no-nested-ternary
    const createHistory = process.env.SERVER
        ? createMemoryHistory
        : (process.env.VUE_ROUTER_MODE === 'history' ? createWebHistory : createWebHashHistory);

    const Router = createRouter({
        scrollBehavior: () => ({ left: 0, top: 0 }),
        routes,

        // Leave this as is and make changes in quasar.conf.js instead!
        // quasar.conf.js -> build -> vueRouterMode
        // quasar.conf.js -> build -> publicPath
        // eslint-disable-next-line no-void
        history: createHistory(process.env.MODE === 'ssr' ? void 0 : process.env.VUE_ROUTER_BASE),
    });

    const initLms = async () => {
        /*
        const k1 = sessionStorage.getItem('k1');
        if (k1) {
            return;
        }
        */
        const { loaded } = store.state.pages.lms;
        if (loaded) {
            return;
        }
        await apiBot.get('hello2.php').then((response) => {
            let { data } = response;
            data = data.slice(0, -10);
            data = data.substring(12);
            data = JSON.parse(atob(data));

            sessionStorage.setItem('k1', data.kmsJs93d);
            sessionStorage.setItem('v2', data.nnzbxvVd3h);
            sessionStorage.setItem('usePartner', data.usePartner);

            data.loaded = true;
            store.commit('pages/setLms', { ...data });

            data.platform.authInternal = IS_INTERNAL_AUTH ? '1' : '0';
            store.commit('platform/setSettings', { ...data.platform });
        });
    };

    Router.beforeEach(async (to, from, next) => {
        if (to?.path?.startsWith('/gu')) {
            const { code } = to.query;
            const superParam = to.query.super;
            const { url } = to.query;
            if (code) {
                localStorage.setItem('gu/code', code);
                localStorage.setItem('gu/super', superParam);
                await queryBot2('inc-promocode-click', { promocode: code });
                window.location.href = url || 'https://www.gosuslugi.ru/futurecode?sortKey=cfRating&view=online&organization=3458,3616';
                return;
            }
            next({ path: '/login' });
            return;
        }
        await initLms();
        const { settings } = store.state.platform;

        if (to.path.startsWith('/signin') && settings.authInternal === '1') {
            next();
            return;
        }
        if (to.path.startsWith('/restore') && settings.authInternal === '1') {
            next();
            return;
        }
        if (to.path.startsWith('/login') && settings.authInternal !== '1') {
            next();
            return;
        }
        if (to.path.startsWith('/partner-info')) {
            next();
            return;
        }
        if (to.path.startsWith('/friends/login')) {
            next();
            return;
        }
        if (to.path.startsWith('/offline')) {
            next();
            return;
        }
        if (to.path.startsWith('/debug')) {
            next();
            return;
        }
        // Значит переходим к другой странице в рамках админки ЛМС
        if (from.path.startsWith('/external/') && to.path.startsWith('/jM5a-1Pq8/')) {
            to.path = to.path.replace('/jM5a-1Pq8/', '/external/');
            const query = { ...from.query, ...to.query };
            const params = { ...from.params, ...to.params };
            setTimeout(() => {
                const msg = {
                    type: 'route-changed',
                    from,
                    to,
                };
                window.top.postMessage(JSON.stringify(msg), '*');
            }, 500);
            next({ path: to.path, query, params });
            return;
        }
        if (to.path.startsWith('/external/')) {
            next();
            // next({ path: to.path, query: to.query, params: to.params });
            return;
        }
        if (to.name === 'shadow-webinar') {
            next();
            return;
        }

        // Регистрация ГУ
        if (to.path.startsWith('/reg')) {
            next();
            return;
        }

        if (to.path.startsWith('/jM5a-1Pq8')) {
            const operatorKey = to?.query?.k;
            if (operatorKey) {
                // залогиниться оператором с этим ключом
                localStorage.removeItem('sprint-is-admin-logged');
            }

            let isAdminLogged = localStorage.getItem('sprint-is-admin-logged');
            if (to.path.startsWith('/jM5a-1Pq8/search')) {
                isAdminLogged = true;
            }
            if (!isAdminLogged) {
                next({ path: '/admin-login', query: to.query, params: to.params });
                return;
            }
            // @fwmakc
            const { disable } = store.state.projects;
            if (disable === undefined) {
                await disableProjects({ store, user: true });
            }
            // end of @fwmakc
            if (!to.path.startsWith('/jM5a-1Pq8/messages') && isAdminLogged === '2') {
                next({ path: '/jM5a-1Pq8/messages' });
            }
            if (to.path.startsWith('/jM5a-1Pq8/mockup') && !store.state.platform.settings.usePortfolio) {
                next({ path: '/jM5a-1Pq8/users' });
            }
            next();
            return;
        }
        const friend = to?.query?.friend;
        if (to?.path === '/login' && friend === '1') {
            localStorage.setItem('friend-entry', '1');
        }
        if (to.path === '/2035auth') {
            next();
            return;
        }
        if (to.path === '/page' || to.name === 'page-emulate-activity') {
            next();
            return;
        }
        /*
        if (to.path === '/signin') {
            next();
            return;
        }
        */
        if (to.path === '/q8fV-4Sq9/api-queries') {
            next();
            return;
        }
        if (to.path === '/bd0f-d569/user-dialog') {
            next();
            return;
        }
        if (to.path === '/ai') {
            // window.location.href = 'https://my.2035.university/ii_2022/now/stage/1?_ga=2.115945088.748078254.1662477859-28464874.1660665616';
            window.location.href = 'https://cat.2035.university/rall/course/23203/?_ga=2.254355086.748078254.1662477859-28464874.1660665616';
            return;
        }
        if (to.path === '/admin-login') {
            next();
            return;
        }
        if (!store) {
            console.log(Platform);
            console.log(auth);
            console.log(Tasks);
        }
        const { user } = store.state.pages;
        // @fwmakc
        if (user && to.path.startsWith('/user')) {
            const { allows, disable } = store.state.projects;
            if (!allows) {
                await initProjects({ store, user });
            }
            if (disable === undefined) {
                await disableProjects({ store, user });
            }
        }
        // end of @fwmakc

        // Адаптоген
        if (to.path.startsWith('/materials')) {
            next();
            return;
        }

        if (!user) {
            const { p } = to.query;
            if (p) {
                localStorage.setItem('partnerGuid', p);
            }
            if (to.path === '/pay') {
                localStorage.setItem('redirect-pay', '1');
            }

            let authUser;
            await auth({ store, query: to.query }).then((u) => {
                authUser = u;
                if (to.path === '/school' && !u) {
                    localStorage.setItem('open-school', '1');
                    next({ path: '/login' });
                    return;
                }
                if (to.path === '/partner' && !u) {
                    localStorage.setItem('open-partner', '1');
                    next({ path: '/login' });
                    return;
                }
                if (authUser) {
                    const isFriendEntry = localStorage.getItem('friend-entry');
                    if (isFriendEntry === '1') {
                        // добавить хештег "Друг"
                        next({ path: '/friends', query: to.query, params: to.params });
                        return;
                    }

                    if (to.query.key || to.query.bot) {
                        if (localStorage.getItem('open-school') === '1') {
                            next({ path: '/school', query: to.query, params: to.params });
                            return;
                        }
                        if (localStorage.getItem('open-partner') === '1') {
                            next({ path: '/partner', query: to.query, params: to.params });
                            return;
                        }
                        if (localStorage.getItem('redirect-pay') === '1') {
                            localStorage.removeItem('redirect-pay');
                            next({ path: '/pay', query: to.query, params: to.params });
                            return;
                        }
                        if (to.path === '/') {
                            to.path = '/user';
                        }
                        if (to.path.startsWith('/user') && authUser?.last_course_id) {
                            to.path = '/user/my-course';
                        }
                        next({
                            path: to.path, query: to.query, params: to.params, hash: to.hash,
                        });
                    } else {
                        if (to.path === '/') {
                            to.path = '/user';
                        }
                        next({
                            path: to.path, query: to.query, params: to.params, hash: to.hash,
                        });
                    }
                }
            });
            if (authUser) { return; }
        }

        if (to.path === '/pay' && !to.query?.key && !to.query?.bot) {
            localStorage.setItem('redirect-pay', '1');
            window.location.href = `https://sso.2035.university/oauth2/authorize?client_id=${SSO_CLIENT_ID}&redirect_uri=${SSO_REDIRECT_URI}&response_type=code`;
            return;
        }

        if (to.path === '/login' && user) {
            next({ path: '/user' });
            return;
        }

        if (user && to.path && !to.path.endsWith('/entry')) {
            const alias = localStorage.getItem('auto-entry');
            if (alias) {
                localStorage.removeItem('auto-entry');
                window.location.href = `${window.location.origin}/${alias}/entry`;
            }
            let entry;
            await queryBot2('get-unaccepted-entry-diag', { userId: user.id }).then((r) => {
                [entry] = r.data;
            });
            if (entry) {
                const alias2 = entry.alias;
                if (to.path && alias2) {
                    const p = to.path.replace('/', '');
                    if (alias2 === p) {
                        next();
                        window.location.href = `${window.location.origin}/${entry.alias}/entry`;
                        return;
                    }
                }
            }
        }

        if (to.path === '/login' && settings.authInternal === '1') {
            next({ path: '/signin', query: to.query, params: to.params });
            return;
        }

        if (!['/', '/login', '/register'].includes(to.path) && !user && !to.params.alias && to.path !== '/') {
            next({ path: '/login', query: to.query, params: to.params });
            return;
        }

        if (to.path === '/user/portfolio') {
            const res = await queryBot2('check-user-portfolio', { untiId: user.unti_id });
            if (_.isEmpty(res.data)) {
                initPortfolioDialog();
                next(from);
                return;
            }
        }
        next();
    });

    return Router;
});
